import { comSessao } from "@/lib/sessaoServidor";
import { LayoutHome } from "@/components/layouts/LayoutHome";
import EventoController from "@/controllers/EventoController";
import { EventoModel } from "@/models/EventoModel";
import { LoteModel } from "@/models/LoteModel";
import ApiHelper, { ResponseProps } from "@/shared/ApiHelper";
import utils from "@/shared/utils";
import analytics, { emReais } from "@/lib/analytics";
import FacebookPixel from '@/components/FacebookPixel';

import {
  Accordion,
  Button,
  Label,
  Modal,
  Tabs,
  TextInput,
  Alert,
} from "flowbite-react";
import { GetServerSideProps, NextApiRequest } from "next";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import InputMask from "react-input-mask";
import MapaGoogle from "@/components/MapaGoogle";
import YouTubeView from "@/components/YouTubeView";
import { AreaModel } from "@/models/AreaModel";
import { MesaModel } from "@/models/MesaModel";
import { useSession } from "next-auth/react";
import { getServerSession } from "next-auth";
import { authOptions } from "../api/auth/[...nextauth]";;
import { toast } from "react-toastify";
import { BsClock, BsClockFill, BsHourglass } from "react-icons/bs";
import {
  FaChevronRight,
  FaFacebook,
  FaMapMarkerAlt,
  FaTwitter,
  FaWhatsapp,
} from "react-icons/fa";
import { RiEarthFill, RiWhatsappFill } from "react-icons/ri";
import { HiClock, HiInformationCircle } from "react-icons/hi";
import HtmlContent from "@/components/HtmlContent";
import * as _ from "lodash";
import moment from "moment-timezone";
import toastCustom from "@/shared/toastCustom";
import {
  ArrowRightIcon,
  LockClosedIcon,
  PlusIcon,
} from "@heroicons/react/24/solid";
import { GoTriangleRight } from "react-icons/go";
import { BiPlusMedical } from "react-icons/bi";
import { ImMinus } from "react-icons/im";
import { VscChromeClose } from "react-icons/vsc";
import ModalFull from "@/components/ModalFull";
import { ArrowUpRightIcon } from "@heroicons/react/24/outline";
import AccordionComponent from "@/components/AccordionComponent";
import PixelGoogle from "@/components/PixelGoogle";
import ShareButton from "@/components/ShareButton";
import AjudaBotao from "@/components/AjudaBotao";
import useScreenSize from "@/components/TamanhoDaTela";
import CartFooterComponent from "@/components/compra/CartFooter";
import SpinnerComponent from "@/components/utils/SpinnerComponent";
import { CartModelProps } from "../checkout/cart";
import { validarTodosItensMesaAssento } from "@/shared/cartMesaValidation";
import { isInAppBrowser } from "@/shared/inAppBrowser";
import { IngressoModel } from "@/models/IngressoModel";
import {
  calcularDescontoCupom,
  cupomValeParaLote,
  descricaoLotesCupom,
  descricaoRegraLote,
} from "@/shared/cupomDesconto";
import { CupomModel, RegrasCupomEventoModel } from "@/models/CupomModel";

interface EventoProps {
  evento: EventoModel;
  lotes: LoteModel[];
  cookie_id: string;
  permiteCupom: false;
  dadosCart: CartProps;
  notFound: false;
  error?: string
}

export type CartProps = {
  qtdCart: string;
  totalCart: string;
  mesasCart: string[];
};

type InscricaoEventoItem = {
  id: number;
  status: "ATIVA" | "CANCELADA";
  enviado_em: string | null;
  inscrito: {
    nome: string;
    cpf: string;
    email: string;
    data_nascimento: string;
    celular: string | null;
  };
  ingresso: {
    id: number;
    numero: number;
    qrcode_hash: string;
    qrcode_url: string;
  };
  evento: { id: number; nome: string; local: string; inicio: string; termino: string } | null;
  area: { id: number; nome: string } | null;
  lote: { id: number; nome: string; titulo: string; impresso: boolean } | null;
};

const getServerSidePropsSemSessao: GetServerSideProps = async (context) => {
  const id = context.query.id;

  let evento: any;
  const lotes: LoteModel[] = [];
  let cookie_id = context?.req?.cookies.cart || 0;
  var permiteCupom = false;
  const session = await getServerSession(context.req, context.res, authOptions);
  let dadosCart: any;
  let notFound = false;
  let areasEvento: AreaModel[] | null = null;

  try {
    const res = await ApiHelper.post({
      url: ApiHelper.eventosPorId,
      method: "POST",
      timezone: context.req.cookies.timezone,
      data: {
        id,
      },
    });

    if (res.response) {
      evento = res.dados;

      try {
        const resAreas = await ApiHelper.post({
          url: ApiHelper.areas,
          method: "POST",
          timezone: context.req.cookies.timezone,
          data: { evento_id: evento.id },
        });
        if (resAreas.response) areasEvento = resAreas.dados;
      } catch {}

      const areasBase = areasEvento ?? evento.areas;

      permiteCupom =
        areasBase.filter((o: AreaModel) => o.cupom_desconto === true).length > 0;

      evento?.lotes?.forEach((item: LoteModel) => {
        const area = evento.areas.filter(
          (o: AreaModel) => o.id == item.area_id
        );

        const objLote: LoteModel = {
          lote_id: item.id,
          area_id: item.area_id,
          nome: item.nome,
          titulo: item.titulo,
          quantidade: 0,
          valor: item.valor ?? 0,
          subtotal: 0,
          evento_id: evento.id,
          cupom_desconto: area.length ? area[0].cupom_desconto : "",
        };

        lotes.push(objLote);
      });
      const arrAreas: any[] = [];
      areasBase?.forEach((area: AreaModel) => {
        const filter = lotes.filter((o: any) => o.area_id == area.id);
        if (filter.length > 0) arrAreas.push(area);
      });

      evento.areas = arrAreas;
    }

    const resCarts = await EventoController.getCart({
      user_id: session?.user.sub,
      cookie_id,
    });

    if (resCarts.dados) {
      dadosCart = utils.setQtdCartCookie(resCarts.dados, false);
      if (resCarts.dados.length === 0) {
        cookie_id = utils.setCookieCart(utils.randomNumber(), true);
        utils.setQtdCartCookie([]);
      }
    }
  } catch (e: any) {
    notFound = true;

    return {
      props: {
        evento: {},
        lotes,
        cookie_id,
        permiteCupom,
        dadosCart: null,
        notFound,
      },
    };
  }

  return {
    props: { evento, lotes, cookie_id, permiteCupom, dadosCart, notFound },
  };
};

export default function EventoDetail(props: EventoProps) {
  const router = useRouter();
  const { data: session } = useSession();
  const [notFound, setNotFound] = useState(props.notFound);
  const tamanhoDaTela = useScreenSize();
  const lotesRef = useRef(new Array());
  const [toastShown, setToastShown] = useState(false);

  const { evento } = props;

  const [areas, setAreas] = useState(evento?.areas ?? []);
  const [cookie_id, setCookieId] = useState(props.cookie_id);
  utils.setCookieCart(cookie_id, true);

  const [areaSelecionada, setAreaSelecionada] = useState<AreaModel>();
  const [lotes, setLotes] = useState<LoteModel[]>(props.lotes);
  const [total, setTotal] = useState(0);

  const [eventoDisponivel, setEventoDisponivel] = useState(false);

  const [verMapaModal, setVerMapaModal] = useState(false);
  const [showAreaModal, setShowAreaModal] = useState(false);
  const [loteSelecionado, setLoteSelecionado] = useState<LoteModel>();
  const [mesas, setMesas] = useState<MesaModel[]>([]);
  const [qtdCart, setQtdCart] = useState<any>(props.dadosCart?.qtdCart ?? "0");
  const [totalCartView, setTotalCartVIew] = useState(
    props.dadosCart?.totalCart ?? "0"
  );
  const [showModalFull, setShowModalFull] = useState(false);
  const [showVideo, setShowVideo] = useState("");
  const [spinnerMesa, setSpinnerMesa] = useState(false);
  const [showModalCapa, setShowModalCapa] = useState(false);
  const [imgCapaArea, setImgCapaArea] = useState("");
  const [cupom, setCupom] = useState("");
  const [cupomAutomaticoAplicado, setCupomAutomaticoAplicado] = useState<
    string | null
  >(null);
  const [regrasCupom, setRegrasCupom] = useState<RegrasCupomEventoModel>({
    lotes: [],
    geral: [],
  });
  const [modalInscricao, setModalInscricao] = useState(false);
  const [modalConsultarInscricao, setModalConsultarInscricao] = useState(false);
  const [loteInscricaoSelecionado, setLoteInscricaoSelecionado] =
    useState<LoteModel>();
  const [inscricaoNome, setInscricaoNome] = useState("");
  const [inscricaoEmail, setInscricaoEmail] = useState("");
  const [inscricaoCpf, setInscricaoCpf] = useState("");
  const [inscricaoDataNascimento, setInscricaoDataNascimento] = useState("");
  const [inscricaoCelular, setInscricaoCelular] = useState("");
  const [qtdInscricoesGerar, setQtdInscricoesGerar] = useState(1);
  const [qtdInscricoesExistentes, setQtdInscricoesExistentes] = useState(0);
  const [spinnerValidarLimiteCpf, setSpinnerValidarLimiteCpf] = useState(false);
  const [consultaCpf, setConsultaCpf] = useState("");
  const [consultaDataNascimento, setConsultaDataNascimento] = useState("");
  const [inscricoesPublicas, setInscricoesPublicas] = useState<
    InscricaoEventoItem[]
  >([]);
  const [spinnerInscricao, setSpinnerInscricao] = useState(false);
  const [spinnerBaixarIngresso, setSpinnerBaixarIngresso] = useState(false);
  const [escolherMapa, setEscolherMapa] = useState(false);
  const [spinner, setSpinner] = useState(false);
  const mesaEmProcessamento = useRef(false);
  let mesasCookie = props.dadosCart?.mesasCart ?? [];

  const ingressoComoMesa = (ing: IngressoModel): MesaModel => ({
    id: ing.id,
    nome: ing.nome,
    area_id: ing.area_id,
    status: "liberado",
  });

  const mergeCartMesasIntoLotes = (
    currentLotes: LoteModel[],
    cartDados: CartModelProps[]
  ): LoteModel[] => {
    const arr = currentLotes.map((l) => ({
      ...l,
      mesas: l.mesas ? [...l.mesas] : undefined,
      desconto_servidor: undefined as number | undefined,
    }));

    cartDados.forEach((card) => {
      const lote = arr.find((l) => l.lote_id === card.lote?.id);
      if (!lote) return;

      lote.quantidade = card.quantidade;
      // subtotal local é sempre o valor bruto; o desconto do cupom é aplicado em calculaTotalDeLotes
      lote.subtotal = card.quantidade * (card.valor ?? lote.valor ?? 0);
      // desconto do cupom (digitado ou automático) já calculado pelo servidor
      lote.desconto_servidor = card.desconto ?? 0;

      if (
        card.area?.nomeclatura === "mesa" ||
        card.area?.nomeclatura === "assento"
      ) {
        lote.mesas = (card.ingressos ?? [])
          .filter((i) => i.ingresso_id == null)
          .map(ingressoComoMesa);
      }
    });

    return arr;
  };

  const idsMesasNoCarrinho = (
    cartDados: CartModelProps[],
    loteId?: number
  ): Set<number> => {
    const ids = new Set<number>();
    cartDados.forEach((card) => {
      if (loteId != null && card.lote?.id !== loteId) return;
      (card.ingressos ?? [])
        .filter((i) => i.ingresso_id == null)
        .forEach((i) => {
          if (i.id != null) ids.add(i.id);
        });
    });
    return ids;
  };

  const atualizarEstadoDoCarrinho = async (): Promise<CartModelProps[] | null> => {
    try {
      const res = await EventoController.getCart({
        user_id: session?.user?.sub,
        cookie_id,
      });

      if (!res.response) return null;

      const cartAutomatico = (res.dados as CartModelProps[]).find(
        (c) => c.cupom?.aplicar_automatico && (c.desconto ?? 0) > 0
      );
      setCupomAutomaticoAplicado(cartAutomatico?.cupom?.nome ?? null);

      setLotes((current) => {
        const merged = mergeCartMesasIntoLotes(current, res.dados);
        const somaTotal = calculaTotalDeLotes(merged);
        setTotal(somaTotal);
        setTotalCartVIew(String(somaTotal));
        return merged;
      });

      const dados = utils.setQtdCartCookie(res.dados, false);
      setQtdCart(dados.qtdCart);
      mesasCookie = dados.mesasCart;

      return res.dados;
    } catch (e) {
      console.log("atualizarEstadoDoCarrinho", e);
      return null;
    }
  };

  const sincronizarSelecaoNoMapa = (
    cartDados: CartModelProps[],
    loteId?: number
  ) => {
    const ids = idsMesasNoCarrinho(cartDados, loteId);
    setMesas((prev) =>
      prev.map((m) => ({
        ...m,
        selecionada: m.id != null && ids.has(m.id),
      }))
    );
  };

  const [windowSize, setWindowSize] = useState({
    width: 0,
    height: 0,
  });

  const validarEventoDisponivel = () => {
    if (notFound && !toastShown) {
      toast.dismiss();
      toast("Evento não disponível!", {
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
      setToastShown(true);
      router.push("/");
    }
  };

  useEffect(() => {
    utils.removeCookie("cupom");

    if (areas.length) {
      setAreaSelecionada(areas[0]);
    }

    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    }

    window.addEventListener("resize", handleResize);
    handleResize(); // Para obter o tamanho inicial
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (notFound && !toastShown) {
      validarEventoDisponivel();
    }
    validaSeDataParaInicioDeVendas();
  }, [toastShown]);

  const monitorCart = async () => {
    try {
      const res = await EventoController.getCart({
        user_id: session?.user.sub,
        cookie_id,
      });
      if (res.response) {
        const qtdCart = String(res.dados.length);
        if (res.dados.length === 0) {
          const new_cookie_id = utils.setCookieCart(utils.randomNumber(), true);
          setCookieId(new_cookie_id);
          utils.setQtdCartCookie([]);
        }
        setQtdCart(qtdCart);
      }
    } catch (e) {
      console.log("###", e);
    }
  };

  const hidratarLotesDoCarrinho = async () => {
    const dados = await atualizarEstadoDoCarrinho();
    if (!dados?.length) return;
  };

  useEffect(() => {
    hidratarLotesDoCarrinho();
  }, [session?.user?.sub, cookie_id]);

  const validaSeDataParaInicioDeVendas = () => {
    if (evento.data_para_venda === "") {
      return setEventoDisponivel(true);
    }

    const dataFormat = moment(evento.data_para_venda, "DD-MM-YYYY").format(
      "YYYY-MM-DD"
    );

    const data =
      evento.data_para_venda === ""
        ? ""
        : `${dataFormat}T${evento.hora_para_venda}`;

    // Verificar se a data é vazia
    if (!data) {
      return setEventoDisponivel(true);
    }

    // Obter a data de hoje
    const hoje = moment();

    // Converter a string de data para um objeto moment
    const dataMoment = moment(data);

    // Verificar se a data é válida
    if (!dataMoment.isValid()) {
      return setEventoDisponivel(true);
    }

    // Comparar a data com a data de hoje
    if (dataMoment.isBefore(hoje)) {
      return setEventoDisponivel(true);
    } else {
      return setEventoDisponivel(false);
    }

    setEventoDisponivel(true);
  };

  const calculaTotalDeLotes = (lotesArr: LoteModel[]) => {
    const cupomObj = utils.getCookie("cupom");
    let cupomJson: CupomModel | null = null;

    if (cupomObj) {
      cupomJson = JSON.parse(cupomObj);
    }

    let somaTotal = 0;

    // total de ingressos do pedido que entram na regra do cupom geral
    const quantidadeTotalPedido = lotesArr
      .filter((item: any) => cupomValeParaLote(cupomJson, item.cupom_desconto == true, item.lote_id))
      .reduce((soma, item) => soma + (item.quantidade ?? 0), 0);

    lotesArr.forEach((item: any) => {
      if (item.quantidade && item.quantidade > 0) {
        var subtotal =
          item.valor != null ? item.valor * item.quantidade : item?.subtotal ?? 0;

        subtotal =
          subtotal -
          (item.desconto_servidor != null
            ? item.desconto_servidor
            : calcularDescontoCupom(
            cupomJson,
            item.cupom_desconto == true,
            item.lote_id,
            item.valor ?? 0,
            item.quantidade,
            quantidadeTotalPedido
          ));
        somaTotal = somaTotal + (subtotal ?? 0);
      }
    });

    return somaTotal;
  };

  const calculaTotal = () => {
    const somaTotal = calculaTotalDeLotes(lotes);
    setTotalCartVIew(String(somaTotal));
    return somaTotal;
  };

  const setQuantidade = async (id: number, somar: boolean) => {
    setLotes((current) =>
      current.map((item) => {
        if (item.lote_id !== id) return { ...item, cookie_id };

        let quantidade = item.quantidade ?? 0;
        if (somar) {
          quantidade += 1;
        } else if (quantidade > 0) {
          quantidade -= 1;
        }

        return {
          ...item,
          cookie_id,
          quantidade,
          subtotal: quantidade * (item.valor ?? 0),
        };
      })
    );

    await atualizarEstadoDoCarrinho();
  };

  const validarMesasAntesCheckout = async (): Promise<boolean> => {
    if (isInAppBrowser()) {
      toastCustom.show({
        mensagem:
          "Para comprar, abra esta página no Chrome ou Safari (menu ⋯ → Abrir no navegador externo).",
        type: "warning",
      });
      return false;
    }

    for (const item of lotes) {
      if (!item.quantidade || item.quantidade <= 0) continue;
      const area = areas.find((a) => a.id === item.area_id);
      if (area && ["mesa", "assento"].includes(area.nomeclatura ?? "")) {
        const qtdMesas = item.mesas?.length ?? 0;
        if (qtdMesas !== item.quantidade) {
          toastCustom.show({
            mensagem: `Escolha ${item.quantidade} ${area.nomeclatura}(s) no mapa antes de continuar.`,
            type: "warning",
          });
          return false;
        }
      }
    }

    try {
      const res = await EventoController.getCart({
        user_id: session?.user?.sub,
        cookie_id,
      });

      if (res.response && res.dados?.length) {
        const check = validarTodosItensMesaAssento(res.dados);
        if (!check.ok) {
          toastCustom.show({
            mensagem:
              check.message ?? "Carrinho de mesas incompleto. Selecione novamente no mapa.",
            type: "error",
          });
          return false;
        }
      }
    } catch {
      toastCustom.show({
        mensagem: "Não foi possível validar o carrinho. Tente novamente.",
        type: "error",
      });
      return false;
    }

    return true;
  };

  const irParaCheckout = async (reservar: boolean) => {
    if (!reservar) {
      const ok = await validarMesasAntesCheckout();
      if (!ok) return;
    }
    router.push(reservar ? "/checkout/reserve" : "/checkout/cart");
  };

  const cart = async (reservar: boolean, addItem: boolean) => {
    const compras: any[] = [];
    let passa = true;

    lotes.forEach((item: any) => {
      if (item.quantidade && item.quantidade > 0) {
        let stringIdsMesas = "";

        const a = areas?.filter((a: any) => a.id == item.area_id);

        if (
          a != null &&
          a[0].nomeclatura != "individual" &&
          item.mesas == undefined
        ) {
          toastCustom.show({
            mensagem:
              "Escolha " + a[0].nomeclatura + " para o lote selecionado",
            type: "warning",
          });

          passa = false;
          return;
        }

        if (item.mesas && item.mesas?.length < item.quantidade) {
          const diferenca = item.quantidade - item.mesas?.length;

          toast(
            `Escolha mais ${diferenca} ${
              a && a[0].nomeclatura
            } para o lote selecionado`,
            {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            }
          );

          passa = false;
          return;
        }

        item.mesas?.forEach((mesa: any) => {
          if (stringIdsMesas == "") {
            stringIdsMesas = ";" + mesa.id;
          } else {
            stringIdsMesas = stringIdsMesas + ";" + mesa.id;
          }
        });

        const obj = {
          area_id: item.area_id,
          cookie_id: item.cookie_id,
          user_id: !reservar ? session?.user.sub : null,
          evento_id: item.evento_id,
          lote_id: item.lote_id,
          nome: item.nome,
          quantidade: item.quantidade,
          subtotal: item.subtotal,
          valor: item.valor,
          ingressos: stringIdsMesas != "" ? stringIdsMesas + ";" : null,
        };

        compras.push(obj);
      }
    });

    if (!passa) return;

    try {
      if (compras.length == 0) {
        toastCustom.show({
          mensagem: "Selecione um ingresso para continuar.",
          type: "warning",
        });
        return;
      }

      const res = await EventoController.addItemCart({
        user_id: !reservar ? session?.user.sub : null,
        cupom: cupom,
        evento_id: evento.id,
        carts: compras,
        addItem: addItem,
      });

      return res;
    } catch (e: any) {
      toastCustom.show({
        mensagem: e.message,
        type: "error",
      });
    }
  };

  const addItemNoCart = async (
    lote: LoteModel,
    somar: boolean,
    mesa?: MesaModel
  ): Promise<ResponseProps> => {
    try {
      if (lote.quantidade == 0 && !somar) {
        return { response: false, dados: null, message: "Falha", status: 404 };
      }

      var stringIdsMesas = "";

      if (mesa) {
        const mesaList = [mesa];

        mesaList?.forEach((mesa: any) => {
          if (stringIdsMesas == "") {
            stringIdsMesas = ";" + mesa.id;
          } else {
            stringIdsMesas = stringIdsMesas + ";" + mesa.id;
          }
        });
      }

      let cupomId = null;
      let cupom = null;
      if (areaSelecionada?.cupom_desconto) {
        const cupomObj = utils.getCookie("cupom");
        let cupomJson = null;

        if (cupomObj) {
          cupomJson = JSON.parse(cupomObj);
          cupomId = cupomJson.id;
          cupom = cupomJson.cupom;
        }
      }

      const obj = {
        cookie_id: cookie_id,
        user_id: session?.user.sub,
        lote_id: lote.lote_id,
        ingressos: stringIdsMesas != "" ? stringIdsMesas + ";" : null,
        somar,
        cupom_id: cupomId,
        cupom,
      };

      setSpinner(true);
      const res = await EventoController.addItemCart(obj);
      setSpinner(false);

      if (res.response) {
        const itemGa = {
          item_id: String(lote.lote_id ?? ""),
          item_name: lote.nome ?? lote.titulo ?? "Ingresso",
          item_category: evento.nome,
          item_variant: areas.find((a: any) => a.id === lote.area_id)?.nome,
          price: emReais(lote.valor),
          quantity: 1,
        };
        somar
          ? analytics.adicionarAoCarrinho(itemGa)
          : analytics.removerDoCarrinho(itemGa);

        if (mesa) {
          const cartDados = await atualizarEstadoDoCarrinho();
          if (cartDados) {
            sincronizarSelecaoNoMapa(cartDados, lote.lote_id);
          }
        } else {
          await setQuantidade(lote?.lote_id ?? 0, somar);
        }
      } else {
        toastCustom.show({
          type: "warning",
          mensagem: res.message,
        });
      }
      return res;
    } catch (e: any) {
      setSpinner(false);
      toastCustom.show({
        type: "warning",
        mensagem: e.message,
      });

      return { response: false, dados: null, message: e.message, status: 404 };
    }
  };

  const comprarAgora = () => {
    router.push("/checkout/cart");
  };

  const temVideo = evento.video_url != undefined && evento.video_url != "";

  const escolherMesa = async (lote: LoteModel, area?: AreaModel) => {
    setSpinnerMesa(true);
    const res = await EventoController.getIngressos(
      lote?.lote_id ?? 0,
      null,
      session?.user.sub
    );

    if (res.response) {
      const loteAtual = lotes.find((l) => l.lote_id === lote.lote_id);
      const idsLocais = new Set(
        (loteAtual?.mesas ?? []).map((m) => m.id).filter(Boolean) as number[]
      );
      const idsCookie = new Set(
        utils.getMesasCookie().map((o: string) => parseInt(o))
      );

      res.dados.forEach((item: any) => {
        item.selecionada =
          idsLocais.has(item.id) || idsCookie.has(item.id);
      });
      setMesas(_.orderBy(res.dados, "id", "asc"));
    }

    setLoteSelecionado(lote);
    setAreaSelecionada(area);
    setVerMapaModal(true);
    setSpinnerMesa(false);
  };

  const temMesaCookie = (id?: number): boolean => {
    var saida = false;
    var temMesaLocal = false;

    lotes.forEach((lote: any) => {
      if (lote.mesas) {
        const arrTem = lote.mesas.filter((o: any) => o.id == id);
        temMesaLocal = arrTem.length > 0;
      }
    });

    const temCookie = utils
      .getMesasCookie()
      .filter((o: string) => parseInt(o) == id);

    if (temCookie.length > 0 && !temMesaLocal) {
      saida = true;
      toastCustom.show({
        type: "warning",
        mensagem: "Está mesa já foi adicionada no carrinho.",
      });
    }

    return saida;
  };

  const selecionarMesa = async (mesa: MesaModel) => {
    if (mesa.status !== "liberado") return;
    if (temMesaCookie(mesa.id)) return;
    if (spinner || mesaEmProcessamento.current) return;

    const lote = lotes.find((l) => l.lote_id === loteSelecionado?.lote_id);
    if (!lote) return;

    const jaTemMesa = lote.mesas?.some((m) => m.id === mesa.id) ?? false;

    mesaEmProcessamento.current = true;
    try {
      await addItemNoCart(lote, !jaTemMesa, mesa);
    } finally {
      mesaEmProcessamento.current = false;
    }
  };

  const removerMesas = async () => {
    const item = lotes.find((l) => l.lote_id === loteSelecionado?.lote_id);
    if (!item?.mesas?.length) return;

    for (const mesa of item.mesas) {
      await addItemNoCart(item, false, mesa);
    }

    const cartDados = await atualizarEstadoDoCarrinho();
    if (cartDados) {
      sincronizarSelecaoNoMapa(cartDados, item.lote_id);
    }
  };

  const verificaMesaSelecionada = (mesaId?: number) => {
    if (mesaId == null) return false;

    const noLote = lotes.some((lote) =>
      lote.mesas?.some((m) => m.id === mesaId)
    );
    if (noLote) return true;

    return utils.getMesasCookie().some((o: string) => parseInt(o) === mesaId);
  };

  const mesaMapa = (mesa: MesaModel) => {
    let cor = "";
    const selecionado =
      mesa.selecionada === true || verificaMesaSelecionada(mesa.id);

    if (selecionado) {
      cor = "bg-green-800";
    } else if (mesa.status == "liberado") {
      cor = "bg-green-500";
    } else if (mesa.status == "reservado") {
      cor = "bg-gray-500";
    } else if (mesa.status == "vendido") {
      cor = "bg-red-500";
    }

    return (
      <div
        key={`mesa-${mesa.id}`}
        onClick={() => selecionarMesa(mesa)}
        className={`${cor} circulo-mesa w-8 h-8`}
      >
        {_.padStart(mesa.nome, 2, "0")}
      </div>
    );
  };

  useEffect(() => {
    if (!evento?.id || !props.permiteCupom) return;

    EventoController.regrasCupom(evento.id)
      .then((res) => {
        if (res.response && res.dados) setRegrasCupom(res.dados);
      })
      .catch(() => {});
  }, [evento?.id]);

  // Bloco do cupom (página e modal de ingressos): campo do código quando a área aceita cupom
  // e a descrição de quais lotes têm cupom e com qual regra.
  const blocoCupom = () => {
    if (!props.permiteCupom || areaSelecionada?.tipo_fluxo === "INSCRICAO")
      return null;

    const aceitaCupom = areaSelecionada?.cupom_desconto == true;
    const regrasDaArea = regrasCupom.lotes.filter(
      (o) => o.area_id == areaSelecionada?.id
    );
    const regrasOutrasAreas = regrasCupom.lotes.filter(
      (o) => o.area_id != areaSelecionada?.id
    );
    const percentual = (valor: number) =>
      `${String(Number(valor)).replace(".", ",")}%`;

    const avisoAutomatico = cupomAutomaticoAplicado && (
      <div className="mt-3 rounded-lg bg-green-50 border border-green-200 p-3 text-sm text-green-700">
        Promoção aplicada automaticamente: <strong>{cupomAutomaticoAplicado}</strong>
      </div>
    );

    const nomeArea = (areaId: number) =>
      areas.find((a: AreaModel) => a.id == areaId)?.nome ?? "";

    const listaRegras = (
      regras: RegrasCupomEventoModel["lotes"],
      comArea: boolean
    ) => (
      <ul className="mt-2 space-y-1 list-disc list-inside">
        {regras.map((r, i) => (
          <li key={`regra-cupom-${r.lote_id}-${i}`}>
            <strong>{r.nome}</strong>
            {comArea && nomeArea(r.area_id) ? ` (${nomeArea(r.area_id)})` : ""}
            : {descricaoRegraLote(r)}
            {r.automatico && r.desconto
              ? ` (promoção automática de ${percentual(r.desconto)})`
              : ""}
          </li>
        ))}
      </ul>
    );

    if (!aceitaCupom) {
      if (areaSelecionada?.esgotar) return null;

      return (
        <div className="border rounded-[20px] p-5 bg-orange-50 border-orange-100 text-sm text-orange-600">
          {regrasOutrasAreas.length > 0 ? (
            <>
              <div>
                 Cupom de desconto disponível para:
              </div>
              {listaRegras(regrasOutrasAreas, true)}
            </>
          ) : (
            "Esta área não aceita cupom de desconto"
          )}
          {avisoAutomatico}
        </div>
      );
    }

    return (
      <div className="border rounded-[20px] p-5 bg-white">
        <div className="xl:flex justify-between items-center gap-3">
          <div className="xl:w-64 text-sm xl:px-4 font-semibold text-gray-700">
            CÓDIGO PROMOCIONAL
          </div>
          <div className="flex justify-between xl:w-2/3 gap-2">
            <div className="xl:w-full w-2/3">
              <TextInput
                id="cupomdesconto"
                type="text"
                value={cupom}
                onChange={(e) => {
                  addCupom(e.target.value);
                }}
                placeholder="Digite o código promocional.."
                required={true}
              />
            </div>
            <div className="flex justify-end">
              <Button
                className="bg-myred hover:bg-myred mr-0 w-40"
                onClick={() => {
                  aplicarDesconto();
                }}
              >
                APLICAR
              </Button>
            </div>
          </div>
        </div>
        {regrasDaArea.length > 0 && (
          <div className="mt-3 text-sm text-gray-600 xl:px-4">
            <div>Lotes desta área com cupom de desconto:</div>
            {listaRegras(regrasDaArea, false)}
          </div>
        )}
        {regrasCupom.geral
          .filter((g) => g.quantidade_exigida || g.automatico)
          .map((g, i) => (
            <div
              key={`regra-cupom-geral-${i}`}
              className="mt-2 text-sm text-gray-600 xl:px-4"
            >
              {g.automatico && g.desconto
                ? `Promoção automática de ${percentual(g.desconto)}`
                : "Cupom válido"}
              {g.quantidade_exigida
                ? ` para pedidos com exatamente ${g.quantidade_exigida} ingresso(s).`
                : " em todos os ingressos desta área."}
            </div>
          ))}
        {avisoAutomatico}
      </div>
    );
  };

  const aplicarDesconto = async () => {
    try {
      const res = await EventoController.getCupom(cupom);

      if (!res.response) {
        toastCustom.show({
          mensagem: "Cupom não encontrado",
          type: "warning",
        });
        return;
      }

      if (res.dados.evento_id != evento.id) {
        toastCustom.show({
          mensagem: "Cupom inválido para este evento.",
          type: "warning",
        });
        return;
      }

      utils.setCookie("cupom", JSON.stringify(res.dados));

      // Aplica o cupom nos itens já no carrinho em uma única chamada (sem remover/readicionar
      // ingressos, o que trocava os ingressos e mostrava valores intermediários).
      const resAplicar = await EventoController.aplicarCupomCart({
        user_id: session?.user.sub,
        cookie_id,
        cupom: res.dados.cupom,
      });

      if (!resAplicar.response) {
        toastCustom.show({
          mensagem: resAplicar.dados,
          type: "warning",
        });
        return;
      }

      await atualizarEstadoDoCarrinho();

      const lotesCupom = descricaoLotesCupom(res.dados);
      toastCustom.show({
        mensagem: lotesCupom
          ? `Código promocional aplicado. Válido para: ${lotesCupom}.`
          : "Código promocional aplicado com sucesso.",
        type: "success",
      });
    } catch (e: any) {
      toastCustom.show({
        mensagem: e.message,
        type: "error",
      });
    }
  };

  const addCupom = async (valor: string) => {
    if (valor == "") {
      utils.removeCookie("cupom");
      setTotal(calculaTotal());
    }

    setCupom(valor);
  };

  const normalizarCpf = (valor: string) =>
    utils.somenteNumeros(valor ?? "") ?? "";

  const formatarCpf = (valor: string) => {
    const digits = normalizarCpf(valor).slice(0, 11);
    if (!digits) return "";
    return digits
      .replace(/^(\d{3})(\d)/, "$1.$2")
      .replace(/^(\d{3})\.(\d{3})(\d)/, "$1.$2.$3")
      .replace(/^(\d{3})\.(\d{3})\.(\d{3})(\d)/, "$1.$2.$3-$4");
  };

  const normalizarTelefone = (valor: string) =>
    (utils.somenteNumeros(valor ?? "") ?? "").slice(0, 11);

  const formatarTelefone = (valor: string) => {
    const digits = normalizarTelefone(valor);
    if (!digits) return "";
    if (digits.length <= 10) {
      return digits
        .replace(/^(\d{2})(\d)/, "($1) $2")
        .replace(/^(\(\d{2}\)\s)(\d{4})(\d)/, "$1$2-$3");
    }
    return digits
      .replace(/^(\d{2})(\d)/, "($1) $2")
      .replace(/^(\(\d{2}\)\s)(\d{5})(\d)/, "$1$2-$3");
  };

  const dataBrParaIso = (valor?: string): string => {
    const v = (valor ?? '').trim();

    if (!v) return '';

    const match = v.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);

    if (!match) return '';

    const [, dd, mm, yyyy] = match;

    return `${yyyy}-${mm}-${dd}`;
  };

  const dataIsoParaBr = (valor?: string): string => {
    const v = (valor ?? '').trim();

    if (!v) return '';

    const match = v.match(/^(\d{4})-(\d{2})-(\d{2})$/);

    if (!match) return '';

    const [, yyyy, mm, dd] = match;

    return `${dd}/${mm}/${yyyy}`;
  };

 const normalizarDataNascimentoParaBr = (valor?: string): string => {
  const v = (valor ?? '').trim();

  if (!v) return '';

  // YYYY-MM-DD
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [yyyy, mm, dd] = v.split('-');
    return `${dd}/${mm}/${yyyy}`;
  }

  // DD/MM/YYYY
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(v)) {
    return v;
  }

  // DDMMYYYY
  const digits = v.replace(/\D/g, '');

  if (digits.length === 8) {
    const dd = digits.substring(0, 2);
    const mm = digits.substring(2, 4);
    const yyyy = digits.substring(4, 8);

    return `${dd}/${mm}/${yyyy}`;
  }

  return '';
};

  const abrirModalInscricaoPublica = (lote: LoteModel) => {
    setLoteInscricaoSelecionado(lote);
    setModalInscricao(true);
    setInscricoesPublicas([]);
    setQtdInscricoesGerar(1);
    setQtdInscricoesExistentes(0);
  };

  const buscarInscricoesExistentesPorCpf = async (params: {
    cpf: string;
    dataNascimentoBr: string;
    eventoId: number;
  }): Promise<InscricaoEventoItem[]> => {
    const res = await ApiHelper.post({
      url: ApiHelper.inscricaoEventoConsultar,
      method: "POST",
      data: {
        cpf: normalizarCpf(params.cpf),
        data_nascimento: dataBrParaIso(params.dataNascimentoBr),
        evento_id: params.eventoId,
      },
    });
    return (res.dados ?? []) as InscricaoEventoItem[];
  };

  const validarLimiteCpfEAtualizar = async (): Promise<{
    existentes: number;
    max: number | null;
    restante: number | null;
  } | null> => {
    if (!evento?.id || !areaSelecionada?.id) return null;

    if (
      !inscricaoCpf ||
      !inscricaoDataNascimento ||
      inscricaoDataNascimento.includes("_") ||
      inscricaoDataNascimento.length !== 10
    ) {
      toastCustom.show({
        mensagem: "Informe CPF e data de nascimento para validar o limite.",
        type: "warning",
      });
      return null;
    }

    setSpinnerValidarLimiteCpf(true);
    try {
      const dataNascimentoBr = normalizarDataNascimentoParaBr(
        inscricaoDataNascimento
      );
      const itens = await buscarInscricoesExistentesPorCpf({
        cpf: inscricaoCpf,
        dataNascimentoBr,
        eventoId: evento.id,
      });

      const existentes = itens.filter(
        (i) => i.status === "ATIVA" && i.area?.id === areaSelecionada.id
      ).length;

      setQtdInscricoesExistentes(existentes);

      const max =
        areaSelecionada?.max_inscricoes_por_cpf == null
          ? null
          : Number(areaSelecionada.max_inscricoes_por_cpf);

      const restante = max == null ? null : Math.max(0, max - existentes);
      return { existentes, max, restante };
    } catch (e: any) {
      toastCustom.show({
        mensagem: e?.message ?? "Não foi possível validar o limite por CPF.",
        type: "error",
      });
      return null;
    } finally {
      setSpinnerValidarLimiteCpf(false);
    }
  };

  const criarInscricaoPublica = async () => {
    if (!evento?.id || !areaSelecionada?.id || !loteInscricaoSelecionado?.lote_id) {
      toastCustom.show({
        mensagem: "Selecione uma área e um lote para continuar.",
        type: "warning",
      });
      return;
    }

    if (
      !inscricaoNome ||
      !inscricaoEmail ||
      !inscricaoCpf ||
      !inscricaoDataNascimento ||
      inscricaoDataNascimento.includes("_") ||
      inscricaoDataNascimento.length !== 10
    ) {
      toastCustom.show({
        mensagem: "Preencha nome, e-mail, CPF e data de nascimento.",
        type: "warning",
      });
      return;
    }

    const dataNascimentoBr = normalizarDataNascimentoParaBr(
      inscricaoDataNascimento
    );
    const dataNascimentoIso = dataBrParaIso(dataNascimentoBr);

    const limite = await validarLimiteCpfEAtualizar();
    if (limite?.max != null && limite.restante != null) {
      if (qtdInscricoesGerar > limite.restante) {
        toastCustom.show({
          mensagem: `Limite por CPF atingido. Restante disponível: ${limite.restante}.`,
          type: "warning",
        });
        return;
      }
    }

    const payloadBase = {
      evento_id: evento.id,
      area_id: areaSelecionada.id,
      lote_id: loteInscricaoSelecionado.lote_id,
      nome: inscricaoNome,
      email: inscricaoEmail,
      cpf: normalizarCpf(inscricaoCpf),
      data_nascimento: dataNascimentoIso,
      celular: inscricaoCelular ? normalizarTelefone(inscricaoCelular) : undefined,
    };

    const idToast = toast.loading("Enviando inscrição...");
    setSpinnerInscricao(true);
    try {
      for (let i = 0; i < qtdInscricoesGerar; i++) {
        await ApiHelper.post({
          url: ApiHelper.inscricaoEventoCriar,
          method: "POST",
          data: payloadBase,
        });
      }
      toast.update(idToast, {
        render: "Inscrição criada com sucesso. O ingresso será enviado no seu e-mail.",
        type: "success",
        isLoading: false,
        autoClose: 3000,
      });

      setModalInscricao(false);
      setModalConsultarInscricao(true);
      setConsultaCpf(payloadBase.cpf);
      setConsultaDataNascimento(dataNascimentoBr);
      await consultarInscricoesPublicas({
        cpf: payloadBase.cpf,
        data_nascimento: dataNascimentoBr,
        evento_id: payloadBase.evento_id,
        showToast: false,
      });
    } catch (e: any) {
      toast.update(idToast, {
        render: e?.message ?? "Não foi possível criar a inscrição.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setSpinnerInscricao(false);
    }
  };

  const consultarInscricoesPublicas = async (params?: {
    cpf?: string;
    data_nascimento?: string;
    evento_id?: number;
    showToast?: boolean;
  }) => {
    const cpf = params?.cpf ?? consultaCpf;
    const data_nascimento_raw = params?.data_nascimento ?? consultaDataNascimento;
    const data_nascimento = normalizarDataNascimentoParaBr(data_nascimento_raw);
    const evento_id = params?.evento_id ?? evento?.id;
    const showToast = params?.showToast ?? true;

    if (
      !cpf ||
      !data_nascimento ||
      data_nascimento.includes("_") ||
      data_nascimento.length !== 10
    ) {
      toastCustom.show({
        mensagem: "Informe CPF e data de nascimento para consultar.",
        type: "warning",
      });
      return;
    }

    setConsultaDataNascimento(data_nascimento);

    const idToast = showToast ? toast.loading("Consultando inscrições...") : null;
    setSpinnerInscricao(true);
    try {
      const res = await ApiHelper.post({
        url: ApiHelper.inscricaoEventoConsultar,
        method: "POST",
        data: {
          cpf: normalizarCpf(cpf),
          data_nascimento: dataBrParaIso(data_nascimento),
          evento_id,
        },
      });
      const itens = (res.dados ?? []) as InscricaoEventoItem[];
      setInscricoesPublicas(itens);
      if (idToast != null) {
        toast.update(idToast, {
          render: "Consulta concluída.",
          type: "success",
          isLoading: false,
          autoClose: 2500,
        });
      }
    } catch (e: any) {
      if (idToast != null) {
        toast.update(idToast, {
          render: e?.message ?? "Não foi possível consultar as inscrições.",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
      } else {
        toastCustom.show({
          mensagem: e?.message ?? "Não foi possível consultar as inscrições.",
          type: "error",
        });
      }
    } finally {
      setSpinnerInscricao(false);
    }
  };

  const nomeArquivoIngressos = (ext: string) => {
    const base = utils.urlAmigavel(evento.nome ?? "evento");
    const cpf = consultaCpf ? `-${consultaCpf}` : "";
    return `${base}-ingressos${cpf}.${ext}`;
  };

  const gerarImagemQrCode = async (item: InscricaoEventoItem) => {
    const hash = item.ingresso?.qrcode_hash;
    if (hash) {
      try {
        const mod: any = await import("qrcode");
        const QRCode = mod?.default ?? mod;
        const dataUrl: string = await QRCode.toDataURL(hash, {
          errorCorrectionLevel: "H",
          margin: 1,
          width: 260,
        });
        const img = new Image();
        img.src = dataUrl;
        await img.decode();
        return img;
      } catch {
        return null;
      }
    }

    const url = item.ingresso?.qrcode_url;
    if (!url) return null;
    try {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.src = url;
      await img.decode();
      return img;
    } catch {
      return null;
    }
  };

  const gerarCanvasIngresso = async (item: InscricaoEventoItem) => {
    const width = 1000;
    const height = 600;
    const canvas = document.createElement("canvas");
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext("2d");
    if (!ctx) return canvas;

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, width, height);

    ctx.strokeStyle = "#111827";
    ctx.lineWidth = 4;
    ctx.strokeRect(16, 16, width - 32, height - 32);

    const eventoNome = item.evento?.nome ?? evento.nome ?? "";
    const ingressoNumero = String(item.ingresso?.numero ?? "");
    const titularNome = item.inscrito?.nome ?? "";
    const titularCpf = item.inscrito?.cpf ?? "";

    ctx.fillStyle = "#111827";
    ctx.font = "bold 36px Arial";
    ctx.fillText(eventoNome, 48, 86);

    ctx.font = "bold 54px Arial";
    ctx.fillText(`Ingresso #${ingressoNumero}`, 48, 170);

    ctx.font = "bold 22px Arial";
    ctx.fillText("Titular", 48, 230);
    ctx.font = "22px Arial";
    ctx.fillText(titularNome, 48, 262);

    ctx.font = "bold 22px Arial";
    ctx.fillText("CPF", 48, 312);
    ctx.font = "22px Arial";
    ctx.fillText(titularCpf, 48, 344);

    ctx.font = "16px Arial";
    ctx.fillStyle = "#6b7280";
    ctx.fillText("Apresente este QR Code na entrada.", 48, 402);

    const qrImg = await gerarImagemQrCode(item);
    if (qrImg) {
      const qrSize = 260;
      const qrX = width - 48 - qrSize;
      const qrY = 170;
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(qrX - 12, qrY - 12, qrSize + 24, qrSize + 24);
      ctx.drawImage(qrImg, qrX, qrY, qrSize, qrSize);
    }

    return canvas;
  };

  const gerarCanvasListaIngressos = async (itens: InscricaoEventoItem[]) => {
    const ticketWidth = 1000;
    const ticketHeight = 600;
    const gap = 40;
    const padding = 40;
    const canvas = document.createElement("canvas");
    canvas.width = ticketWidth;
    canvas.height =
      padding + itens.length * ticketHeight + Math.max(0, itens.length - 1) * gap + padding;
    const ctx = canvas.getContext("2d");
    if (!ctx) return canvas;

    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    let y = padding;
    for (const item of itens) {
      const ticketCanvas = await gerarCanvasIngresso(item);
      ctx.drawImage(ticketCanvas, 0, y);
      y += ticketHeight + gap;
    }

    return canvas;
  };

  const baixarIngressosComoImagem = async (itens: InscricaoEventoItem[]) => {
    if (!itens.length) return;
    setSpinnerBaixarIngresso(true);
    try {
      const canvas = await gerarCanvasListaIngressos(itens);
      const blob: Blob | null = await new Promise((resolve) =>
        canvas.toBlob((b) => resolve(b), "image/png")
      );
      if (!blob) return;
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = nomeArquivoIngressos("png");
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(url);
    } finally {
      setSpinnerBaixarIngresso(false);
    }
  };

  const baixarIngressosComoPdf = async (itens: InscricaoEventoItem[]) => {
    if (!itens.length) return;
    setSpinnerBaixarIngresso(true);
    try {
      const dataUrls: string[] = [];
      for (const item of itens) {
        const canvas = await gerarCanvasIngresso(item);
        dataUrls.push(canvas.toDataURL("image/png"));
      }
      const w = window.open("", "_blank");
      if (!w) return;
      const title = nomeArquivoIngressos("pdf");
      const imgs = dataUrls
        .map(
          (src) =>
            `<div style="page-break-after: always; display:flex; justify-content:center;"><img src="${src}" style="width:100%; max-width:900px;" /></div>`
        )
        .join("");
      w.document.open();
      w.document.write(`
        <html>
          <head>
            <title>${title}</title>
            <style>
              body { margin: 0; padding: 0; }
              @page { margin: 10mm; }
            </style>
          </head>
          <body>
            ${imgs}
            <script>
              window.onload = function () { window.print(); };
            </script>
          </body>
        </html>
      `);
      w.document.close();
    } finally {
      setSpinnerBaixarIngresso(false);
    }
  };

  const shareData = {
    title: evento.nome,
    text: evento.diaPorExtenso,
    url: "http://agenciamixshows.com.br" + router.asPath,
  };

  const lotesDaAreaSelecionada = lotes.filter(
    (o) => o.area_id == areaSelecionada?.id && !areaSelecionada?.esgotar
  );

  const abrirModalArea = (area: AreaModel) => {
    setAreaSelecionada(area);
    setShowAreaModal(true);
  };

  const mostrarCapaArea = (img: string) => {
    setImgCapaArea(img);
    setShowModalCapa(true);
  };

  const escolherMapaFunction = () => {
    if (areaSelecionada?.video_mapa) {
      setEscolherMapa(true);
    } else {
      mostrarCapaArea(evento.mapa);
    }
  };

  const mostrarVideo = (url?: string) => {
    if (url) {
      setShowVideo(url);
      setShowModalFull(true);
    }
  };

  const compartilhar = (rede: "whatsapp" | "facebook" | "x") => {
    const url = encodeURIComponent(window.location.href);
    const texto = encodeURIComponent(evento.nome ?? "");
    const links = {
      whatsapp: `https://wa.me/?text=${texto}%20${url}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
      x: `https://twitter.com/intent/tweet?text=${texto}&url=${url}`,
    };

    window.open(links[rede], "_blank", "noopener,noreferrer");
  };

  const renderInfoSectionTitle = (titulo: string) => (
    <div className="flex items-center gap-3 mb-6">
      <div className="h-px flex-1 bg-gray-200" />
      <h2 className="text-xl md:text-2xl font-bold tracking-wide text-gray-900 uppercase">
        {titulo}
      </h2>
      <div className="h-px flex-1 bg-gray-200" />
    </div>
  );

  return (
    <>
      {props.evento.pixel_facebook !== '' && (
         <FacebookPixel pixelId={props.evento.pixel_facebook ?? ""} />
      )}
      {evento.id && (
        <>
          <SpinnerComponent show={spinner} />
          {/* <AjudaBotao
            numero={
              evento.promotor != null &&
              evento.promotor?.telefone_comercial != null &&
              evento.promotor?.telefone_comercial != ""
                ? `${utils.somenteNumeros(evento.promotor?.telefone_comercial)}`
                : ""
            }
          /> */}
          {totalCartView !== "0" && (
            <CartFooterComponent
              qtdCart={qtdCart}
              total={totalCartView}
              onBeforeCheckout={validarMesasAntesCheckout}
            />
          )}
          <LayoutHome marginBotton={totalCartView !== "0" ? 60 : undefined} qtdCart={qtdCart}>
            <div className="relative h-44 md:h-72 bg-gray-900 overflow-hidden">
              <img
                src={evento.banner || evento.capa}
                alt=""
                className={`w-full h-full object-cover ${
                  evento.banner ? "" : "blur-md scale-110 opacity-70"
                }`}
              />
            </div>
            <div className="max-w-6xl mx-auto px-4 md:px-6">
              <section className="relative -mt-24 md:-mt-40 grid md:grid-cols-[300px,1fr] gap-6 md:gap-10 items-end">
                <div className="mx-auto w-64 md:w-full bg-white rounded-2xl shadow-xl overflow-hidden">
                  <img src={evento.capa} alt={evento.nome} className="w-full aspect-square object-cover" />
                  <div className="flex items-center justify-center gap-4 py-3 text-gray-500">
                    <span className="text-xs">Compartilhar</span>
                    <button type="button" aria-label="Compartilhar no WhatsApp" onClick={() => compartilhar("whatsapp")}>
                      <FaWhatsapp className="text-lg" />
                    </button>
                    <button type="button" aria-label="Compartilhar no Facebook" onClick={() => compartilhar("facebook")}>
                      <FaFacebook className="text-lg" />
                    </button>
                    <button type="button" aria-label="Compartilhar no X" onClick={() => compartilhar("x")}>
                      <FaTwitter className="text-lg" />
                    </button>
                  </div>
                </div>
                <div className="text-center md:text-left md:pb-4 md:pt-44">
                  <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3">
                    {evento.nome}
                  </h1>
                  <div className="space-y-2 text-gray-700">
                    <p className="flex items-center justify-center md:justify-start gap-2">
                      <HiClock className="text-myred shrink-0" />
                      {evento.diaPorExtenso} - {evento.horaInicio}h
                    </p>
                    <p>
                      <FaMapMarkerAlt className="text-myred inline mr-2 align-[-2px]" />
                      {evento.local} - {evento.cidade}/{evento.estado}
                    </p>
                  </div>
                  <div className="flex flex-wrap justify-center md:justify-start gap-2 mt-4 text-xs font-medium text-gray-700">
                    {evento.censura != undefined && (
                      <span className="rounded-full bg-gray-100 px-3 py-1">
                        Classificação {evento.censura}+
                      </span>
                    )}
                    {evento.publico != undefined &&
                      evento.publico != null &&
                      evento.publico > 0 && (
                        <span className="rounded-full bg-gray-100 px-3 py-1">
                          Público esperado: {evento.publico}
                        </span>
                      )}
                  </div>
                </div>
              </section>
            </div>

            <nav
              aria-label="Seções do evento"
              className="mt-8 border-y border-gray-200 bg-white"
            >
              <div className="max-w-6xl mx-auto px-4 md:px-6 flex justify-center gap-6 overflow-x-auto py-3 text-sm font-medium text-gray-700 whitespace-nowrap">
                <a href="#ingressos" className="hover:text-myred">Ingressos</a>
                {evento.latitude && evento.latitude != "" && (
                  <a href="#localizacao" className="hover:text-myred">Localização</a>
                )}
                {evento.pdvs && evento.pdvs.length > 0 && (
                  <a href="#pdvs" className="hover:text-myred">PDVs</a>
                )}
                <a href="#informacoes" className="hover:text-myred">Informações</a>
                {temVideo && <a href="#video" className="hover:text-myred">Vídeo</a>}
              </div>
            </nav>

            <div className="max-w-6xl mx-auto px-4 md:px-6 py-8 md:py-10 space-y-12">
              <section id="ingressos" className="scroll-mt-24 max-w-3xl mx-auto">
                {evento.mapa && evento.mapa != "" && (
                  <div className="mb-10 space-y-4">
                    <img
                      className="w-full rounded-2xl border border-gray-100 cursor-pointer"
                      src={evento.mapa}
                      alt={`Mapa do evento ${evento.nome}`}
                      onClick={() => mostrarCapaArea(evento.mapa)}
                    />
                    <div className="flex flex-wrap justify-center gap-3">
                      <Button
                        className="bg-myblue hover:bg-myblue"
                        onClick={() => mostrarCapaArea(evento.mapa)}
                      >
                        AMPLIAR MAPA
                      </Button>
                      {areaSelecionada?.video_mapa && (
                        <Button
                          color="light"
                          onClick={() => mostrarVideo(areaSelecionada?.video_mapa)}
                        >
                          VER VÍDEO DO MAPA
                        </Button>
                      )}
                    </div>
                  </div>
                )}

                {renderInfoSectionTitle(
                  areas?.length > 0 &&
                    areas.every((area: AreaModel) => area.tipo_fluxo === "INSCRICAO")
                    ? "Faça sua inscrição"
                    : "Adquira seu ingresso agora"
                )}

                {eventoDisponivel === false && evento.data_para_venda !== "" && (
                  <div className="mb-6">
                    <Alert color="failure" icon={HiInformationCircle}>
                      Vendas liberadas a partir de{" "}
                      {moment(evento.data_para_venda, "DD-MM-YYYY").format(
                        "DD/MM/YYYY"
                      )}{" "}
                      {evento.hora_para_venda}
                    </Alert>
                  </div>
                )}

                <div className="space-y-3">
                  {areas?.map((area) => {
                    const lotesArea = lotes.filter((o) => o.area_id === area.id);
                    const precoInicial = _.min(
                      lotesArea.map((item) => Number(item.valor ?? 0))
                    );
                    const capaArea = area.capa || area.imagem || evento.capa;

                    return (
                      <button
                        key={`area-card-${area.id}`}
                        type="button"
                        onClick={() => abrirModalArea(area)}
                        className="w-full flex items-center gap-4 text-left rounded-xl border border-gray-200 bg-white p-4 shadow-sm hover:border-gray-400 hover:shadow-md transition-all"
                      >
                        {capaArea && (
                          <img
                            src={capaArea}
                            alt={area.nome}
                            className="w-20 h-20 md:w-24 md:h-24 rounded-lg object-cover shrink-0"
                          />
                        )}
                        <div className="flex-1 min-w-0">
                          <h3 className="flex items-center gap-2 font-bold text-gray-900">
                            <span
                              className="w-3 h-3 rounded-full border border-gray-300 shrink-0"
                              style={{ backgroundColor: area.cor ?? "#111827" }}
                            />
                            {area.nome}
                          </h3>
                          {area.acesso && (
                            <p className="linhas-2 text-sm text-gray-500 mt-1">
                              {area.acesso}
                            </p>
                          )}
                          {area.esgotar ? (
                            <p className="text-xs font-semibold text-red-600 mt-1 uppercase">
                              Indisponível
                            </p>
                          ) : area.tipo_fluxo === "INSCRICAO" ? (
                            <p className="text-xs text-gray-500 mt-1">Inscrição</p>
                          ) : (
                            precoInicial != null &&
                            precoInicial > 0 && (
                              <p className="text-xs text-gray-500 mt-1">
                                A partir de{" "}
                                <strong className="text-gray-900">
                                  {utils.currencyRegex(String(precoInicial), true)}
                                </strong>
                              </p>
                            )
                          )}
                        </div>
                        <FaChevronRight className="text-myred shrink-0" />
                      </button>
                    );
                  })}
                </div>

                <div className="mt-6">{blocoCupom()}</div>

                {total > 0 && areaSelecionada?.tipo_fluxo !== "INSCRICAO" && (
                  <div className="xl:flex justify-between items-center mt-6 gap-3 border rounded-[20px] p-5 bg-gray-900 text-white">
                    <div className="text-2xl text-center lg:text-left">
                      TOTAL:{" "}
                      <strong className="text-3xl">
                        {utils.currencyRegex(total.toString(), true)}
                      </strong>
                    </div>
                    <div className="md:flex hidden lg:justify-end justify-center items-start gap-2 mt-5 lg:mt-0 w-auto lg:w-40">
                      <Button
                        className="hover:bg-myblue h-14 bg-myblue"
                        onClick={() => {
                          void irParaCheckout(false);
                        }}
                        size="sm"
                      >
                        COMPRAR AGORA
                      </Button>
                    </div>
                  </div>
                )}
              </section>

              <section id="informacoes" className="scroll-mt-24 bg-gray-50 border border-gray-200 rounded-2xl p-5 md:p-7">
                {renderInfoSectionTitle("Informações")}

                {areaSelecionada?.tipo_fluxo === "INSCRICAO" ? (
                  <div className="flex justify-end mb-6">
                    <Button
                      size="sm"
                      className="bg-myblue text-white"
                      onClick={() => {
                        setModalConsultarInscricao(true);
                        setInscricoesPublicas([]);
                      }}
                    >
                      CONSULTAR MINHAS INSCRIÇÕES
                    </Button>
                  </div>
                ) : (
                  ""
                )}

                <div className="grid lg:grid-cols-[1.5fr,0.9fr] gap-8">
                  <div className="space-y-8">
                    {temVideo && (
                      <div id="video" className="scroll-mt-24 rounded-[20px] overflow-hidden border border-gray-100">
                        <YouTubeView url={evento.video_url ?? ""} width="100%" />
                      </div>
                    )}

                    {evento.descricao && evento.descricao != "" && (
                      <div className="prose max-w-none">
                        <HtmlContent content={evento.descricao} />
                      </div>
                    )}

                    {evento.descricao_areas && evento.descricao_areas != "" && (
                      <div className="border-t border-gray-100 pt-6">
                        <h3 className="text-lg font-bold mb-4">Sobre as áreas</h3>
                        <HtmlContent content={evento.descricao_areas} />
                      </div>
                    )}
                  </div>

                  <div className="space-y-5">
                    <div className="border border-gray-200 rounded-[20px] p-5 bg-white">
                      <h3 className="text-lg font-bold mb-4 text-gray-900">
                        Produtor
                      </h3>
                      <div className="space-y-2 text-sm text-gray-600">
                        <p>
                          <strong className="text-gray-900">Produtor:</strong>{" "}
                          {evento.promotor?.razao}
                        </p>
                        {evento.promotor?.cnpj && (
                          <p>
                            <strong className="text-gray-900">CNPJ:</strong>{" "}
                            {evento.promotor?.cnpj}
                          </p>
                        )}
                        {evento.promotor?.cpf && (
                          <p>
                            <strong className="text-gray-900">CPF:</strong>{" "}
                            {evento.promotor?.cpf}
                          </p>
                        )}
                        {evento.promotor?.telefone_comercial !== "" && (
                          <p>
                            <strong className="text-gray-900">Whatsapp:</strong>{" "}
                            <Link
                              className="text-blue-500"
                              href={`https://wa.me/55${utils.somenteNumeros(
                                evento.promotor?.telefone_comercial
                              )}?text=Ol%C3%A1%2C+vim+pelo+ind%C3%BAstriadoingresso.com+e+preciso+de+ajuda.`}
                              target="_blank"
                            >
                              {evento.promotor?.telefone_comercial}
                            </Link>
                          </p>
                        )}
                        {evento?.promotor?.instagram !== "" && (
                          <p>
                            <strong className="text-gray-900">Instagram:</strong>{" "}
                            <Link
                              className="text-blue-500"
                              href={`https://instagram.com/${evento?.promotor?.instagram}`}
                              target="_blank"
                            >
                              @{evento?.promotor?.instagram ?? ""}
                            </Link>
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="border border-gray-200 rounded-[20px] p-5 bg-white">
                      <h3 className="text-lg font-bold mb-4 text-gray-900">
                        Atendimento
                      </h3>
                      <div className="space-y-3 text-sm text-gray-600">
                        <p className="flex items-start gap-3">
                          <BsClockFill className="text-myred mt-0.5" />
                          <span>Informações do evento e compra disponíveis nesta página.</span>
                        </p>
                        {evento.promotor?.telefone_comercial && (
                          <p className="flex items-start gap-3">
                            <RiWhatsappFill className="text-green-600 mt-0.5" />
                            <span>{evento.promotor.telefone_comercial}</span>
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </section>

              {evento.latitude && evento.latitude != "" && (
                <section id="localizacao" className="scroll-mt-24">
                  {renderInfoSectionTitle("Localização")}
                  <div className="rounded-[20px] overflow-hidden border border-gray-100">
                    <MapaGoogle
                      width="100%"
                      height="500px"
                      center={{
                        lat: parseFloat(evento.latitude ?? "0"),
                        lng: parseFloat(evento.longitude ?? "0"),
                      }}
                      markers={[
                        {
                          lat: parseFloat(evento.latitude ?? "0"),
                          lng: parseFloat(evento.longitude ?? "0"),
                        },
                      ]}
                    />
                  </div>
                </section>
              )}

              {evento.pdvs && evento.pdvs.length > 0 && (
                <section id="pdvs" className="scroll-mt-24">
                  {renderInfoSectionTitle("Pontos de Venda")}
                  <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {evento.pdvs?.map((pdv) => (
                      <div
                        key={`pdv${pdv.id}`}
                        className="border border-gray-200 rounded-xl bg-white overflow-hidden"
                      >
                        {pdv.endereco?.cidade && (
                          <div
                            key={`endereco-cidade${pdv.id}`}
                            className="bg-gray-100 px-4 py-3 text-sm font-semibold uppercase text-gray-900"
                          >
                            {pdv.endereco?.cidade?.nome}/
                            {pdv.endereco?.cidade?.estado.sigla}
                          </div>
                        )}
                        <div className="p-4">
                          <div className="font-medium text-gray-900 mb-1">
                            {pdv.nome}
                          </div>
                          {pdv.endereco?.cidade && (
                            <p
                              key={`endereco-endereco${pdv.id}`}
                              className="text-sm text-gray-500"
                            >
                              {pdv.endereco?.rua}, {pdv.endereco?.numero}{" "}
                              {pdv.endereco?.bairro}
                            </p>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </section>
              )}
            </div>
            <Modal
              show={showAreaModal}
              onClose={() => setShowAreaModal(false)}
              size="5xl"
            >
              <Modal.Header>
                {"Ingressos: " + areaSelecionada?.nome || "Ingressos"}
              </Modal.Header>
              <Modal.Body>
                <div className="space-y-6">
                  <div className="grid lg:grid-cols-[260px,1fr] gap-6">
                    <div className="space-y-4">
                      {(areaSelecionada?.capa ||
                        areaSelecionada?.imagem ||
                        evento.capa) && (
                        <img
                          src={
                            areaSelecionada?.capa ||
                            areaSelecionada?.imagem ||
                            evento.capa
                          }
                          alt={areaSelecionada?.nome}
                          className="w-full h-52 object-cover rounded-[18px]"
                        />
                      )}
                      {areaSelecionada?.acesso && (
                        <div className="rounded-[18px] bg-gray-50 border border-gray-100 p-4 text-sm text-gray-600">
                          {areaSelecionada.acesso}
                        </div>
                      )}
                      <div className="flex flex-wrap gap-2">
                        {evento.mapa != null && evento.mapa != "" && (
                          <Button
                            color="light"
                            onClick={() => {
                              escolherMapaFunction();
                            }}
                          >
                            VER MAPA
                          </Button>
                        )}
                        {areaSelecionada?.video != null &&
                          areaSelecionada?.video != "" && (
                            <Button
                              color="light"
                              onClick={() => {
                                mostrarVideo(areaSelecionada.video);
                              }}
                            >
                              VÍDEO EXPLICATIVO
                            </Button>
                          )}
                      </div>
                    </div>

                    <div className="space-y-4">
                      {areaSelecionada?.esgotar && (
                        <div className="text-sm text-white bg-red-600 p-3 rounded-md uppercase font-bold text-center">
                          Os ingressos para {areaSelecionada.nome} estão indisponíveis.
                        </div>
                      )}

                      {areaSelecionada?.tipo_fluxo === "INSCRICAO" ? (
                        <div className="space-y-4">
                          <div className="text-sm text-gray-600">
                            {areaSelecionada?.max_inscricoes_por_cpf != null && (
                              <span>
                                Limite por CPF:{" "}
                                <strong>
                                  {areaSelecionada.max_inscricoes_por_cpf}
                                </strong>{" "}
                                inscrição(ões)
                              </span>
                            )}
                          </div>

                          {lotesDaAreaSelecionada.map((lote) => (
                            <div
                              key={`area-lote-inscricao-${lote.lote_id}`}
                              className="border rounded-[18px] border-gray-200 p-4"
                            >
                              <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                                <div className="text-sm">
                                  {lote.titulo && lote.titulo != "" && (
                                    <div className="text-gray-500 mb-1">
                                      Ingresso: {lote.titulo}
                                    </div>
                                  )}
                                  <div className="font-bold text-base text-gray-900">
                                    {areaSelecionada?.nome} - {lote.nome}
                                  </div>
                                  {evento.censura != undefined && (
                                    <div className="text-xs text-gray-500 mt-1">
                                      Classificação {evento?.censura}+
                                    </div>
                                  )}
                                </div>
                                <Button
                                  size="sm"
                                  className="bg-myblue"
                                  onClick={() => abrirModalInscricaoPublica(lote)}
                                >
                                  REALIZAR INSCRIÇÃO
                                </Button>
                              </div>
                            </div>
                          ))}
                        </div>
                      ) : (
                        <div className="space-y-4">
                          {lotesDaAreaSelecionada.map((lote) => (
                            <div
                              key={`area-lote-${lote.lote_id}`}
                              className="border rounded-[18px] border-gray-200 overflow-hidden"
                              ref={(element) => lotesRef.current.push(element)}
                            >
                              <div className="p-4 bg-gray-50 border-b border-gray-200">
                                <div className="grid grid-cols-1 md:grid-cols-2 items-start gap-4">
                                  <div>
                                    <div className="flex items-center gap-2">
                                      <span
                                        className="w-3 h-3 rounded-full"
                                        style={{
                                          backgroundColor:
                                            areaSelecionada?.cor ?? "#111827",
                                        }}
                                      />
                                      <span className="font-bold text-lg text-gray-900">
                                        {areaSelecionada?.nome} - {lote.nome}
                                      </span>
                                    </div>
                                    {lote.titulo && lote.titulo != "" && (
                                      <div className="text-sm text-gray-500 mt-2">
                                        Ingresso: {lote.titulo}
                                      </div>
                                    )}
                                  </div>
                                  <div className="text-left md:text-right">
                                    <div className="text-sm text-gray-500">
                                      Valor
                                    </div>
                                    <strong className="text-2xl text-gray-900">
                                      {utils.currencyRegex(
                                        lote.valor?.toString() ?? "",
                                        true
                                      )}
                                    </strong>
                                  </div>
                                </div>
                              </div>

                              <div className="p-4">
                                <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
                                  <div className="text-sm text-gray-500">
                                    {evento.censura != undefined && (
                                      <span>Classificação {evento?.censura}+ </span>
                                    )}
                                  </div>

                                  {areaSelecionada?.nomeclatura == "individual" ? (
                                    <div className="grid grid-cols-3 items-center w-[140px]">
                                      <div>
                                        <div
                                          onClick={() =>
                                            addItemNoCart(lote ?? 0, false)
                                          }
                                          className="btn-qtd bg-gray-300"
                                        >
                                          <ImMinus className="text-gray-500" />
                                        </div>
                                      </div>
                                      <div className="flex justify-center items-center font-semibold">
                                        {lote.quantidade}
                                      </div>
                                      <div>
                                        <div
                                          onClick={() =>
                                            addItemNoCart(lote ?? 0, true)
                                          }
                                          className="btn-qtd bg-blue-700"
                                        >
                                          <BiPlusMedical className="text-white" />
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="flex justify-end">
                                      <Button
                                        size="sm"
                                        className="border-2"
                                        color="light"
                                        onClick={() => {
                                          escolherMesa(lote, areaSelecionada);
                                        }}
                                        style={{
                                          borderColor: areaSelecionada?.cor,
                                          color: areaSelecionada?.cor,
                                        }}
                                      >
                                        {spinnerMesa
                                          ? "BUSCANDO.."
                                          : `ESCOLHER ${
                                              areaSelecionada?.nome?.split(" ")[0]
                                            }`}
                                      </Button>
                                    </div>
                                  )}
                                </div>

                                {areaSelecionada?.nomeclatura != "individual" && (
                                  <div
                                    key={`area-mesa-${areaSelecionada?.id}`}
                                    className="mt-5 border-t border-gray-100 pt-4"
                                  >
                                    <div className="text-gray-500 text-sm mb-3">
                                      Mesas/Assentos selecionados:
                                    </div>
                                    <div className="flex gap-3 flex-wrap">
                                      {_.orderBy(
                                        lote.mesas ?? [],
                                        "id",
                                        "asc"
                                      ).map((mesa) => (
                                        <div
                                          key={`mesa-resumo-${mesa.id}`}
                                          className="circulo-mesa bg-green-800 w-12 h-12"
                                        >
                                          {_.padStart(mesa.nome ?? "", 2, "0")}
                                        </div>
                                      ))}
                                      {(lote.mesas ?? []).length === 0 && (
                                        <span className="text-xs text-gray-400">
                                          Nenhuma mesa selecionada
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                  {blocoCupom()}
                </div>
              </Modal.Body>
              <Modal.Footer className="flex justify-end items-center gap-2">
                {total > 0 && areaSelecionada?.tipo_fluxo !== "INSCRICAO" && (
                  <div className="mr-auto text-lg">
                    TOTAL:{" "}
                    <strong>{utils.currencyRegex(total.toString(), true)}</strong>
                  </div>
                )}
                {total > 0 && areaSelecionada?.tipo_fluxo !== "INSCRICAO" && (
                  <Button
                    className="bg-myred hover:bg-myred"
                    onClick={() => {
                      setShowAreaModal(false);
                      void irParaCheckout(false);
                    }}
                  >
                    COMPRAR AGORA
                  </Button>
                )}
                <Button color="light" onClick={() => setShowAreaModal(false)}>
                  Fechar
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal
              show={escolherMapa}
              onClose={() => setEscolherMapa(false)}
              size="sm"
            >
              <Modal.Header>Escolha o tipo de mapa</Modal.Header>
              <Modal.Body>
                <div className="flex justify-between gap-2">
                  <Button
                    color="gray"
                    className="w-full"
                    onClick={() => {
                      mostrarCapaArea(evento.mapa);
                      setEscolherMapa(false);
                    }}
                  >
                    Imagem
                  </Button>
                  <Button
                    color="gray"
                    className="w-full"
                    onClick={() => {
                      mostrarVideo(areaSelecionada?.video_mapa);
                      setEscolherMapa(false);
                    }}
                  >
                    Vídeo
                  </Button>
                </div>
              </Modal.Body>
            </Modal>

            <Modal
              key={`modal-key`}
              show={verMapaModal}
              onClose={() => {
                setVerMapaModal(false);
              }}
              size="5xl"
              className="h-screen"
            >
              <Modal.Header>Mapa</Modal.Header>
              <Modal.Body>
                <div className="space-y-6">
                  <div className="grid lg:grid-cols-3 gap-3">
                    <div className={areaSelecionada?.imagem ? "" : ""}>
                      {areaSelecionada?.imagem && (
                        <>
                          <div
                            key="mapaAreaModal"
                            className="flex justify-center bg-gray-100"
                          >
                            <img
                              onClick={() => {
                                mostrarCapaArea(areaSelecionada?.imagem ?? "");
                              }}
                              src={areaSelecionada?.imagem}
                              className="rounded-md cursor-pointer"
                              style={{ maxWidth: "200px", width: "200px" }}
                            />
                          </div>
                        </>
                      )}

                      {areaSelecionada?.video &&
                        areaSelecionada?.video != "" && (
                          <>
                            <div className="w-full">
                              <Button
                                onClick={() => {
                                  mostrarVideo(areaSelecionada.video);
                                }}
                                className="bg-myred w-full rounded-md mt-3 font-bold text-2xl hover:bg-myred"
                              >
                                ASSISTIR VÍDEO
                              </Button>
                            </div>
                          </>
                        )}
                    </div>
                    <div className="md:lg-0 mt-5 w-full lg:col-span-2">
                      <p className="font-bold text-2xl ">
                        {areaSelecionada?.nome}
                      </p>
                      <p className="mb-4 text-gray-500 text-justify">
                        {areaSelecionada?.acesso}
                      </p>
                      <hr />
                      <p className="mt-5 mb-">STATUS:</p>
                      <hr />
                      <div className="flex justify-between mt-5">
                        <div className="flex flex-col items-center justify-center">
                          <div className="rounded-full bg-green-500 w-7 h-7"></div>{" "}
                          Liberado
                        </div>
                        <div className="flex flex-col items-center justify-center">
                          <div className="rounded-full bg-gray-500 w-7 h-7"></div>{" "}
                          Reservado
                        </div>
                        <div className="flex flex-col items-center justify-center">
                          <div className="rounded-full bg-red-500 w-7 h-7"></div>{" "}
                          Indisponível
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-wrap gap-1">
                    {mesas?.map((mesa) => (
                      <>{mesaMapa(mesa)}</>
                    ))}
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer className="flex justify-end">
                <Button
                  color="light"
                  onClick={() => {
                    setVerMapaModal(false);
                  }}
                >
                  Fechar
                </Button>
                <Button
                  color="gray"
                  onClick={() => {
                    removerMesas();
                  }}
                >
                  Limpar
                </Button>
                <Button
                  className="bg-myblue"
                  onClick={() => {
                    setVerMapaModal(false);
                  }}
                >
                  Confirmar
                </Button>
              </Modal.Footer>
            </Modal>
          </LayoutHome>

          <Modal
            show={modalInscricao}
            onClose={() => setModalInscricao(false)}
            size="lg"
          >
            <Modal.Header>Inscrição</Modal.Header>
            <Modal.Body>
              <div className="space-y-4">
                <div className="text-sm text-gray-600">
                  {loteInscricaoSelecionado?.titulo &&
                  loteInscricaoSelecionado.titulo !== "" ? (
                    <div>
                      <strong>{loteInscricaoSelecionado.titulo}</strong>
                    </div>
                  ) : null}
                  <div>
                    {areaSelecionada?.nome} - {loteInscricaoSelecionado?.nome}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <div className="mb-2 block">
                      <Label htmlFor="inscricao_nome" value="Nome" />
                    </div>
                    <TextInput
                      id="inscricao_nome"
                      type="text"
                      value={inscricaoNome}
                      onChange={(e) => setInscricaoNome(e.target.value)}
                      required={true}
                    />
                  </div>
                  <div>
                    <div className="mb-2 block">
                      <Label htmlFor="inscricao_email" value="E-mail" />
                    </div>
                    <TextInput
                      id="inscricao_email"
                      type="email"
                      value={inscricaoEmail}
                      onChange={(e) => setInscricaoEmail(e.target.value)}
                      required={true}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <div className="mb-2 block">
                      <Label htmlFor="inscricao_cpf" value="CPF" />
                    </div>
                    <TextInput
                      id="inscricao_cpf"
                      type="text"
                      value={formatarCpf(inscricaoCpf)}
                      onChange={(e) => setInscricaoCpf(normalizarCpf(e.target.value))}
                      maxLength={14}
                      required={true}
                    />
                  </div>
                  <div>
                    <div className="mb-2 block">
                      <Label
                        htmlFor="inscricao_data_nascimento"
                        value="Data de nascimento"
                      />
                    </div>
                    <InputMask
                      id="inscricao_data_nascimento"
                      className="block w-full border disabled:cursor-not-allowed disabled:opacity-50 bg-gray-50 border-gray-300 text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500 rounded-lg p-2.5 text-sm"
                      mask="99/99/9999"
                      placeholder="DD/MM/AAAA"
                      value={inscricaoDataNascimento}
                      onChange={(e) => setInscricaoDataNascimento(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="inscricao_celular" value="Celular (opcional)" />
                  </div>
                  <TextInput
                    id="inscricao_celular"
                    type="text"
                    value={formatarTelefone(inscricaoCelular)}
                    onChange={(e) =>
                      setInscricaoCelular(normalizarTelefone(e.target.value))
                    }
                    maxLength={15}
                  />
                </div>

                <div className="border rounded-md p-3">
                  <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                    <div>
                      <div className="font-semibold">Quantidade de inscrições</div>
                      <div className="text-xs text-gray-600">
                        {areaSelecionada?.max_inscricoes_por_cpf != null ? (
                          <>
                            Limite por CPF:{" "}
                            <strong>{areaSelecionada.max_inscricoes_por_cpf}</strong>{" "}
                            · Existentes (ATIVAS):{" "}
                            <strong>{qtdInscricoesExistentes}</strong>
                          </>
                        ) : (
                          <>
                            Limite por CPF: <strong>não definido</strong> · Existentes
                            (ATIVAS): <strong>{qtdInscricoesExistentes}</strong>
                          </>
                        )}
                      </div>
                    </div>

                    <div className="grid grid-cols-3 items-center w-28">
                      <div>
                        <div
                          onClick={() =>
                            setQtdInscricoesGerar((q) => Math.max(1, q - 1))
                          }
                          className="btn-qtd bg-gray-300"
                        >
                          <ImMinus className="text-gray-500" />
                        </div>
                      </div>
                      <div className="flex justify-center items-center">
                        {spinnerValidarLimiteCpf ? "..." : qtdInscricoesGerar}
                      </div>
                      <div>
                        <div
                          onClick={() => {
                            void (async () => {
                              const limite = await validarLimiteCpfEAtualizar();
                              if (limite?.max != null && limite.restante != null) {
                                if (qtdInscricoesGerar + 1 > limite.restante) {
                                  toastCustom.show({
                                    mensagem: `Limite por CPF atingido. Restante disponível: ${limite.restante}.`,
                                    type: "warning",
                                  });
                                  return;
                                }
                              }
                              setQtdInscricoesGerar((q) => q + 1);
                            })();
                          }}
                          className={`btn-qtd ${
                            spinnerValidarLimiteCpf ? "bg-gray-400" : "bg-blue-700"
                          }`}
                        >
                          <BiPlusMedical className="text-white" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {inscricoesPublicas.length > 0 && (
                  <div className="border-t pt-4 space-y-3">
                    {inscricoesPublicas.map((item) => (
                      <div
                        key={`inscricao-retorno-${item.id}`}
                        className="border rounded-md p-3 text-sm"
                      >
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-2">
                          <div>
                            <div className="font-semibold">
                              {item.evento?.nome ?? evento.nome}
                            </div>
                            <div className="text-gray-600">
                              Status: <strong>{item.status}</strong>
                            </div>
                            <div className="text-gray-600">
                              Ingresso: <strong>{item.ingresso.numero}</strong>
                            </div>
                          </div>
                        </div>
                        {item.ingresso.qrcode_url && (
                          <div className="mt-3 flex justify-center">
                            <img
                              src={item.ingresso.qrcode_url}
                              alt=""
                              style={{ width: "220px", maxHeight: "220px" }}
                            />
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer className="flex justify-end">
              <Button color="light" onClick={() => setModalInscricao(false)}>
                Fechar
              </Button>
              <Button
                className="bg-myblue"
                disabled={spinnerInscricao}
                onClick={() => void criarInscricaoPublica()}
              >
                {spinnerInscricao ? "Aguarde..." : "Enviar"}
              </Button>
            </Modal.Footer>
          </Modal>

          <Modal
            show={modalConsultarInscricao}
            onClose={() => setModalConsultarInscricao(false)}
            size="lg"
          >
            <Modal.Header>Consultar inscrição</Modal.Header>
            <Modal.Body className="max-h-[75vh] overflow-y-auto">
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                  <div>
                    <div className="mb-2 block">
                      <Label htmlFor="consulta_cpf" value="CPF" />
                    </div>
                    <TextInput
                      id="consulta_cpf"
                      type="text"
                      value={formatarCpf(consultaCpf)}
                      onChange={(e) => setConsultaCpf(normalizarCpf(e.target.value))}
                      maxLength={14}
                      required={true}
                    />
                  </div>
                  <div>
                    <div className="mb-2 block">
                      <Label
                        htmlFor="consulta_data_nascimento"
                        value="Data de nascimento"
                      />
                    </div>
                    <InputMask
                      id="consulta_data_nascimento"
                      className="block w-full border disabled:cursor-not-allowed disabled:opacity-50 bg-gray-50 border-gray-300 text-gray-900 focus:border-blue-500 focus:ring-blue-500 dark:border-gray-600 dark:bg-gray-700 dark:text-white dark:placeholder-gray-400 dark:focus:border-blue-500 dark:focus:ring-blue-500 rounded-lg p-2.5 text-sm"
                      mask="99/99/9999"
                      placeholder="DD/MM/AAAA"
                      value={consultaDataNascimento}
                      onChange={(e) => setConsultaDataNascimento(e.target.value)}
                    />
                  </div>
                </div>

                {inscricoesPublicas.length > 0 && (
                  <div className="border-t pt-4 space-y-3">
                    {inscricoesPublicas.map((item) => (
                      <div
                        key={`inscricao-consulta-${item.id}`}
                        className="border rounded-md p-4"
                      >
                        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                          <div className="space-y-1">
                            <div className="text-lg font-semibold">
                              {item.evento?.nome ?? evento.nome}
                            </div>
                            <div className="text-gray-600 text-sm">
                              Ingresso: <strong>{item.ingresso.numero}</strong>
                            </div>
                            <div className="text-gray-600 text-sm">
                              Titular: <strong>{item.inscrito.nome}</strong>
                            </div>
                            <div className="text-gray-600 text-sm">
                              CPF: <strong>{item.inscrito.cpf}</strong>
                            </div>
                          </div>
                          <div className="flex flex-col items-center gap-2">
                            {item.ingresso.qrcode_url && (
                              <img
                                src={item.ingresso.qrcode_url}
                                alt=""
                                style={{ width: "220px", maxHeight: "220px" }}
                              />
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </Modal.Body>
            <Modal.Footer className="flex justify-end">
              <Button
                color="light"
                onClick={() => setModalConsultarInscricao(false)}
              >
                Fechar
              </Button>
              {inscricoesPublicas.length > 0 && (
                <>
                  <Button
                    className="bg-myblue"
                    disabled={spinnerBaixarIngresso}
                    onClick={() => void baixarIngressosComoPdf(inscricoesPublicas)}
                  >
                    {spinnerBaixarIngresso ? "Aguarde..." : "Baixar"}
                  </Button>
                </>
              )}
              <Button
                className="bg-myblue"
                disabled={spinnerInscricao}
                onClick={() => void consultarInscricoesPublicas()}
              >
                {spinnerInscricao ? "Aguarde..." : "Consultar"}
              </Button>
            </Modal.Footer>
          </Modal>

          <ModalFull
            show={showModalFull}
            onClick={() => {
              setShowModalFull(false);
            }}
          >
            <div className="lg:w-2/4 w-full mx-3 text-white">
              <YouTubeView
                url={showVideo}
                width="100%"
                height={`${windowSize.height * 0.7}`}
              />
            </div>
          </ModalFull>

          <ModalFull
            show={showModalCapa}
            onClick={() => {
              setShowModalCapa(false);
            }}
          >
            <div className="lg:w-2/4 w-full mx-3 text-white ">
              <img
                src={imgCapaArea}
                alt=""
                style={{
                  maxHeight: tamanhoDaTela.height - 20,
                  margin: "0 auto",
                }}
              />
            </div>
          </ModalFull>

          <PixelGoogle
            script={props.evento.pixel_google_script ?? ""}
            noscript={props.evento.pixel_google_noscript ?? ""}
          />
        </>
      )}
      {!evento.id && (
        <LayoutHome qtdCart={qtdCart}>
          <div className="md:container mx-auto py-5 grid md:grid-cols-3 sm:px-10 mb-10">
            Evento não encontrado....
          </div>
          </LayoutHome>
      )}

    </>
  );
}

EventoDetail.layout = LayoutHome;

export const getServerSideProps = comSessao(getServerSidePropsSemSessao);
